import { isEmpty } from 'lodash'

import { hasAnySim, isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta10ExemplosEnum,
  ConsultaSeguimentoPergunta10Model,
} from './model-consultaSeguimentoPergunta10'

const pergunta10ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta10ExemplosEnum)

export function isPergunta10ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllFilled(allExemplos, pergunta10ExemplosEnumValues)
}

export function isPergunta10ExemplosAllNao(value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta10ExemplosEnumValues)
}

export function hasPergunta10ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta10ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}
